import { render, staticRenderFns } from "./ReservationConfirm.vue?vue&type=template&id=039d3bd8&"
import script from "./ReservationConfirm.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports